export default "__VITE_ASSET__DIgWHKHa__"